<template lang="pug">
  #dashboard-assessment-widget
    BLoading(:is-full-page="false" :active.sync="isLoading")
      .is-syncing-loader.has-text-weight-bold.is-size-1 Syncing...
    .assessment-dashboard
      WtTitle(card-title) Be Well Assessment
      p {{ assessmentParagraph }}
      br
      WtButton.custom-button(
          isRouterLink
          color="primary"
          size="medium"
          :to="{ name: 'Assessment' }"
        ) {{ buttonText }}
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DashboardAssessmentWidget",
  components: {
    WtButton,
    WtTitle
  },
  data() {
    return {
      assessmentSubmitted: false,
      assessmentUpdatedDate: null,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters("companion", ["getAssessmentData"]),

    buttonText() {
      return this.assessmentSubmitted
        ? "Retake Assessment"
        : "Begin Assessment";
    },

    assessmentParagraph() {
      return this.assessmentSubmitted
        ? "Update your assessment responses to help us ensure your wellness plan reflects your current needs."
        : "Take the assessment to help us create your personalized wellness plan.";
    }
  },

  async mounted() {
    this.isLoading = true;
    try {
      let assessmentData = this.getAssessmentData();

      if (!assessmentData || Object.keys(assessmentData).length === 0) {
        assessmentData = await this.fetchAssessmentData();
      }

      this.assessmentSubmitted = assessmentData.data.AssessmentSubmitted;
      this.assessmentUpdatedDate = assessmentData.data.UpdatedDate;
      this.isLoading = false;
    } catch (e) {
      this.snackBar({
        duration: 5000,
        type: "is-danger",
        message: "Failed to load assessment data"
      });
      this.isLoading = false;
    }
  },
  methods: {
    ...mapActions("companion", ["fetchAssessmentData"]),
    ...mapActions(["snackBar"])
  }
};
</script>

<style lang="sass" scoped>
#dashboard-assessment-widget
    .custom-button
        font-weight: 400 !important
</style>
